import React, { useState } from "react";
import Api from "../../../Api/api";
import { toast } from "react-toastify";

const AdminEditFunctionsTable = ({ title, id, portal, index, onUpdate }) => {
    const [loading, setLoading] = useState(false);
    const [functionEdit, setFunctionEdit] = useState(false);
    const [functionTitle, setFunctionTitle] = useState(title);

    function save() {
        setLoading(true);
        let data = new FormData();
        data.append('ID', id);
        data.append('function', functionTitle);
        data.append('portal', portal);

        Api().post('/sp_setRespFunction', data).then(res => {
            toast.success('Update erfolgreich');
            setFunctionEdit(false);
            setLoading(false);
            if (onUpdate) {
                onUpdate();
            }
        }).catch(e => {
            toast.error('Update konnte nicht durchgeführt werden!');
            setLoading(false);
        });
    }

    return (
        <tbody>
            <tr className={index % 2 === 1 ? 'bg-white' : 'bg-offWhite'}>
                <td className="px-2 py-2 text-sm text-grey">{id}</td>
                <td style={{ textTransform: 'none', color: functionTitle ? '#1c1c1c' : '#a6a6a6' }} onClick={() => setFunctionEdit(true)}>
                    {
                        !functionEdit && functionTitle ? functionTitle : !functionEdit && 'Hier ist noch eine leere Option'
                    }
                    {
                        functionEdit &&
                        <input value={functionTitle}
                            style={{ width: '100%', backgroundColor: 'whitesmoke', padding: '10px 5px' }}
                            onChange={(e) => setFunctionTitle(e.target.value)}
                            placeholder='Funktion Name' />
                    }
                </td>
                <td onClick={save}>
                    <button className='px-3 py-1 bg-mainBlue text-white rounded rounded-md'>
                        {loading ? 'speichere...' : 'Speichern'}
                    </button>
                </td>
            </tr>
        </tbody>
    );
};

export default AdminEditFunctionsTable;